var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"marketplace-error-wrapper",attrs:{"fx":"","fxCol":"","fxCenter":"","fxACenter":""}},[_c('DynamicImage',{attrs:{"icon":_vm.icon,"height":130}}),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }